// import { flickity } from "flickity";
var SmoothScroll = require('smooth-scroll');
var Flickity = require('flickity');
import { Menu } from "./components/Menu";
import { ScrollSpy } from "./components/ScrollSpy";

/**
^ * Main App class.
 */
class App{
  /**
  * Constructor
   */
  constructor() {
    var scroll = new SmoothScroll('a[href*="#"]');
    const menu = new Menu().init();
    const scrollSpy = new ScrollSpy().init();
    if(document.querySelector('.headerCarousel') !== null) {
      const headerCarousel = new Flickity( '.headerCarousel', {
        "wrapAround": true,
        "contain": true,
        "autoPlay": 5000,
        "pauseAutoPlayOnHover": false,
        "arrowShape": "M76.6389 96.0922C77.662 97.8264 76.389 100 74.3547 100L55.0379 100C54.1248 100 53.2802 99.5372 52.7954 98.7755L23.9078 53.13C22.6974 51.2142 22.6974 48.7887 23.9078 46.8758L52.7954 1.22448C53.2772 0.462845 54.1248 1.36051e-06 55.0379 1.40042e-06L74.3518 2.24466e-06C76.389 2.33371e-06 77.659 2.1736 76.6359 3.90778C76.6359 3.90778 51.1239 46.539 50.3804 47.8396C49.6369 49.1402 49.5477 50.3471 50.3209 51.7532C51.1002 53.1505 76.6389 96.0922 76.6389 96.0922Z"
      });
      const slides = headerCarousel.getCellElements();
      const allBoxes = document.querySelectorAll('.headerCarousel__infobox');
      headerCarousel.on('change', function(index) {
        const current = allBoxes[index];
        const previous = index !== 0 ? allBoxes[index-1] : allBoxes[1];
        previous.classList.add('opacity-0');
        current.classList.remove('opacity-0');
      })
    }
    if(document.querySelector('.newsCarousel') !== null) {
      const newsCarousel = new Flickity( '.newsCarousel', {
        "cellAlign": "left",
        "pageDots": false,
        "contain": true,
        "arrowShape": "M76.6389 96.0922C77.662 97.8264 76.389 100 74.3547 100L55.0379 100C54.1248 100 53.2802 99.5372 52.7954 98.7755L23.9078 53.13C22.6974 51.2142 22.6974 48.7887 23.9078 46.8758L52.7954 1.22448C53.2772 0.462845 54.1248 1.36051e-06 55.0379 1.40042e-06L74.3518 2.24466e-06C76.389 2.33371e-06 77.659 2.1736 76.6359 3.90778C76.6359 3.90778 51.1239 46.539 50.3804 47.8396C49.6369 49.1402 49.5477 50.3471 50.3209 51.7532C51.1002 53.1505 76.6389 96.0922 76.6389 96.0922Z"
      });
      newsCarousel.on('change', function(index) {
      })
    };
  }

}

const app = new App();
export default app;


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
